import script from "./ModulesVideosResoursesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ModulesVideosResoursesComponent.vue?vue&type=script&setup=true&lang=js"

import "./ModulesVideosResoursesComponent.vue?vue&type=style&index=0&id=6182c87f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6182c87f"]])

export default __exports__